import { render } from "./StreamSidebarPreview.vue?vue&type=template&id=dda254cc"
import script from "./StreamSidebarPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamSidebarPreview.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/StreamSidebar/StreamSidebarPreview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dda254cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dda254cc', __exports__)) {
    api.reload('dda254cc', __exports__)
  }
  
  module.hot.accept("./StreamSidebarPreview.vue?vue&type=template&id=dda254cc", () => {
    api.rerender('dda254cc', render)
  })

}


export default __exports__